// Module
var code = "<div>Source: <a class=\"bold source\">{{srcShortName}}</a>, {{srcTable}}.{{srcCol}}</div> <div>Target: <a class=\"bold target\">{{targetShortName}}</a>, {{tarTable}}.{{tarCol}}</div> <div class=\"italic pl-8px pt-8px\">{{message}}</div> ";
// Exports
export default code;